<template>
	<v-container fluid>
		<v-breadcrumbs style="font-weight: 600" :items="localizedBreadcrumbs" divider=">"></v-breadcrumbs>
		<v-card>

			{{ certificateNames }}
			<v-card-header class="d-flex">
				<v-avatar icon="mdi-account-circle" size="80"></v-avatar>
				<h4 class="my-auto">{{ $t('select_specific_agent') }} <span> ({{ $t('optional') }}) </span></h4>
			</v-card-header>
			<v-card-text>
				<SelectAgentDataTable :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
					@assign-agent="assignIncidentToAgent">
				</SelectAgentDataTable>
			</v-card-text>
			<v-card-footer>
				<div class="d-flex flex-row-reverse">
					<v-btn class="ma-5 px-10" elevation="0" @click="openDispatchDialog = true">
						{{ $t('skip_to_broadcast') }}
						<v-icon size="x-large">
							mdi-arrow-right-bold-circle-outline
						</v-icon>
					</v-btn>
				</div>
			</v-card-footer>
		</v-card>
	</v-container>
	<v-dialog v-model="openDispatchDialog" width="500">
		<v-card width="500">
			<div class="font-weight-bold ma-5 text-center">
				{{ $t('incident_broadcast_notice') }},
				<span class="text-red-lighten-3">
					{{ $t('check_job_details') }}.
				</span>
			</div>
			<v-card-footer class="bg-black">
				<div class="d-flex justify-space-between ma-2">
					<v-btn elevation="0" class="bg-black" @click="openDispatchDialog = false">{{ $t('cancel')
					}}</v-btn><v-btn elevation="0" class="bg-black" @click="createIncident">{{ $t('dispatch')
						}}</v-btn>
				</div>
			</v-card-footer>
		</v-card>
	</v-dialog>
	<v-dialog v-model="assignAgent" width="auto" persistent>
		<v-card width="700">
			<div class="ma-5">
				<v-row>
					<v-col cols="3">
						<v-avatar size="150" image="@/assets/userphoto.jpg" class="mt-4"></v-avatar>
					</v-col>

					<v-col cols="9">
						<div class="ml-5">
							<div class="d-flex justify-space-between">
								<div class="text-h5 font-weight-bold">
									<div>
										{{ $t('line_name') }}:
										{{ selectedAgent.lineName }}
									</div>
								</div>

								<div class="font-weight-bold cursor-pointer">
									<a href="#" class="agent-profile-link" @click="agentProfile(selectedAgent.id)">
										{{ $t('see_agent_profile') }}
										<v-icon>mdi-chevron-right</v-icon>
									</a>
								</div>
							</div>

							<v-row class="mt-2">
								<v-col cols="6" class="text-body-2">
									<div class="text-h6 text-grey-darkn-1 my-2">
										{{ selectedAgent.designation }}
									</div>
									<div class="text-grey">
										<div>
											{{
												`${selectedAgent.firstName} ${selectedAgent.lastName}`
											}}
										</div>
										<div>{{ selectedAgent.phone }}</div>
										<div>{{ selectedAgent.email }}</div>
										<div>
											{{ selectedAgent.address }}
										</div>
									</div>
								</v-col>
								<v-divider vertical=""></v-divider>
								<v-col cols="6" class="text-body-2">
									<div class="text-body-1 font-weight-bold">
										Specialization Skills
									</div>
									<div class="text-body-2 font-weight-bold">
										{{ selectedAgent.specialization }}
									</div>
									<div class="mt-2 text-body-1 font-weight-bold">{{ $t('skill_required') }}</div>

									<div class="mt-2">
										<v-chip v-for="skill in selectedAgent.skills" class="ma-1" size="small"
											:key="skill.id" :style="{
												'background-color': colorGenerator(skill.name),
											}">
											<span style="color: #fff; font-weight: 500">
												{{ skill.name }}
											</span>
										</v-chip>

										<v-chip v-for="cert in selectedAgent.certificates" class="ma-1" size="small"
											:key="cert.id" :style="{
												'background-color': colorGenerator(
													cert.CertificateName.certificateName
												),
											}">
											<span style="color: #fff; font-weight: 500">
												{{ cert.CertificateName.certificateName }}
											</span>
										</v-chip>
									</div>
								</v-col>
							</v-row>
						</div>
					</v-col>
				</v-row>
			</div>
			<v-card-footer class="bg-black w-100 d-flex justify-space-between mt-2 pa-2">
				<v-btn elevation="0" class="bg-black text-white" @click="assignAgent = false">
					{{ $t('cancel') }}
				</v-btn>
				<v-btn class="bg-black text-white" @click="dispatchIncidentToAgent(agentId)">{{ $t('assign') }}</v-btn>
			</v-card-footer>
		</v-card>
	</v-dialog>
</template>
<script>
import agentService from '@/services/API/agentService'
import SelectAgentDataTable from '@/components/SelectAgentDataTable.vue'
import incidentService from '@/services/API/incidentService'

export default {
	components: {
		SelectAgentDataTable,
	},

	created() {
		this.fetchAgentList()
	},

	data: () => ({
		incident: {},
		agentId: '',
		selectedAgent: {},
		agentDetails: {},
		openDispatchDialog: false,
		assignAgent: false,
		items: '',
		headers: [
			{
				text: 'Agent Detail',
				value: 'agentDetial',
				sortable: true,
				width: '20%',
			},

			{
				text: 'Skills and Certificates',
				value: 'skills',
				width: '35%',
			},
			{
				text: '',
				value: 'assignButton',
				width: '15%',
			},
		],
		create_incident: [
			{
				title: 'Incident List',
				disabled: false,
				href: '/',
			},
			{
				title: 'Create incident',
				disabled: false,
				href: '/create-incident',
			},
			{
				title: 'Select Specific agent',
				disabled: true,
			},
		],
	}),
	computed: {
		localizedBreadcrumbs() {
			return [
				{ title: this.$t('create_an_incident'), disabled: false, color: 'grey', href: '/' },
				{ title: this.$t('incident_list'), color: 'grey', disabled: false },
				{ title: this.$t('specific_agent'), color: 'black', disabled: false }
			];
		},
	},
	methods: {
		async dispatchIncidentToAgent(agentId) {
			// Retrieve and update incident data
			let incidentData = JSON.parse(localStorage.getItem('incidentData'));
			incidentData.userId = agentId;
			// Save the updated data back to localStorage
			localStorage.setItem('incidentData', JSON.stringify(incidentData));
			try {
				let response;
				if (this.$route.query.type === "esg") {
					response = await incidentService.createEsgIncident(incidentData);
				} else {
					response = await incidentService.createIncident(incidentData);
				}

				if (response.status === 200) {
					localStorage.removeItem('incidentData');
					this.$store.state.snackBar = {
						display: true,
						text: 'Successfully created.',
						color: 'green',
					};
					this.$emit('success');
					this.$router.push(`/`);
				} else {
					this.$store.state.snackBar = {
						display: true,
						text: 'Could not create Incident',
						color: 'red',
					};
				}
			} catch (error) {
				console.error('Error creating incident:', error);
				this.$store.state.snackBar = {
					display: true,
					text: 'Error occurred while creating the incident.',
					color: 'red',
				};
			}
		},
		agentProfile(id) {
			const agentProfileUrl = `/agent-list/verified-agent/agent-information?agentId=${id}`
			window.open(agentProfileUrl, '_blank')
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) * 16777215
				)
			).toString(16)
			return `#${hex}`
		},
		async getAgentDetail(id) {
			await agentService.getSingleAgent(id).then((response) => {
				if (response.status == 200) {
					this.selectedAgent = response.data
				}
			})
		},
		assignIncidentToAgent(id) {
			this.agentId = id
			this.getAgentDetail(id)
			this.assignAgent = true
		},
		async createIncident() {
			if (this.$route.query.type === "esg") {
				await incidentService
					.createEsgIncident(JSON.parse(localStorage.getItem('incidentData')))
					.then((response) => {
						if (response.status === 200) {
							localStorage.removeItem('incidentData')
							this.$store.state.snackBar = {
								display: true,
								text: 'Successfully created.',
								color: 'green',
							}
							this.$emit('success')
							this.$router.push(`/`)
						} else {
							this.$store.state.snackBar = {
								display: true,
								text: 'Could not create Incident',
								color: 'red',
							}
						}
					})
					.catch((error) => {
						// Handle API call error
						console.error('Error creating incident:', error)
					})
			}
			else {

				await incidentService
					.createIncident(JSON.parse(localStorage.getItem('incidentData')))
					.then((response) => {
						if (response.status === 200) {
							localStorage.removeItem('incidentData')
							this.$store.state.snackBar = {
								display: true,
								text: 'Successfully created.',
								color: 'green',
							}
							this.$emit('success')
							this.$router.push(`/`)
						} else {
							this.$store.state.snackBar = {
								display: true,
								text: 'Could not create Incident',
								color: 'red',
							}
						}
					})
					.catch((error) => {
						// Handle API call error
						console.error('Error creating incident:', error)
					})
			}

		},
		async fetchAgentList() {
			// const certificateNameId = JSON.parse(
			// 	localStorage.getItem('incidentData')
			// ).certificates
			this.isFetchingAgents = true
			await agentService
				.agentMatchingCertificate(this.$route.query.type)
				.then((response) => {
					this.items = response.data
				})
		},
	},
}
</script>
<style scoped>
.agent-profile-link {
	text-decoration: none;
	color: black;
}
</style>
